import moment from "moment/moment";
import { useContext } from "react";
import { createContext, useState, useRef } from "react";
import { useMutation, useQuery } from "react-query";
import {
  createTimeLog,
  getTimeLogsForWorkOrder,
} from "../../../../../services/Production/workOrderClient";
import { toast } from "react-toastify";

const TimeLoggerContext = createContext();

export default function TimeLogsProvider({
  children,
  onAddTimeLog,
  workOrderId,
  onStartTimeLog,
}) {
  return (
    <TimeLoggerContext.Provider
      value={useTimeLogger({ onAddTimeLog, workOrderId, onStartTimeLog })}
    >
      {children}
    </TimeLoggerContext.Provider>
  );
}

export function useTimeLogger({ onStartTimeLog, onAddTimeLog, workOrderId }) {
  const timerId = useRef(null);
  const startRef = useRef(null);

  const [seconds, setSeconds] = useState(0);
  const [isStarted, setIsStarted] = useState(false);

  const { data, refetch } = useQuery(
    ["TimeLogs", workOrderId],
    getTimeLogsForWorkOrder
  );

  const { mutateAsync } = useMutation({
    mutationFn: createTimeLog,
  });

  function startTimer() {
    if (onStartTimeLog) onStartTimeLog();
    if (!timerId?.current) startRef.current = new Date(Date.now());
    setIsStarted(true);
    if (!isStarted)
      timerId.current = setInterval(() => {
        setSeconds((prev) => prev + 1);
      }, 1000);
  }

  function pauseTimer() {
    setIsStarted(false);
    clearInterval(timerId?.current);
  }

  async function stopTimer() {
    if (!timerId?.current) return;
    const toastId = toast.loading("Ajout Time log");
    const timeLog = {
      start: moment(startRef.current.toISOString()).format(
        "yyyy-MM-DD HH:mm:ss"
      ),
      end: moment().format("yyyy-MM-DD HH:mm:ss"),
      duration: seconds,
    };
    console.log(timeLog);
    try {
      await mutateAsync({
        workOrderId,
        timeLog,
      });
      refetch();
      reset();
      // if (onAddTimeLog) onAddTimeLog(timeLog);
      toast.update(toastId, {
        render: "Ajout avec succès",
        type: "success",
        autoClose: 1000,
        isLoading: false,
      });
    } catch (error) {
      toast.update(toastId, {
        render: error?.response?.data?.message || "Erreur est survenu",
        type: "error",
        autoClose: 1000,
        isLoading: false,
      });
    }
  }

  const reset = () => {
    pauseTimer();
    timerId.current = null;
    setSeconds(0);
    setIsStarted(false);
  };

  // if (timeLogs.some((timeLog) => timeLog.timerId === timerId.current)) {
  //   onAddTimeLog(timeLogs);
  //   reset();
  // }

  return { startTimer, stopTimer, pauseTimer, timeLogs: data || [], seconds };
}

export function useTimeLoggerContext() {
  return useContext(TimeLoggerContext);
}
